import React from 'react';
import DynamicPage from '../components/DynamicPage';

const GalleryPage: React.FC = () => {
  return (
    <DynamicPage 
      pageType="gallery"
      title=""
      backButtonText="Back to Home"
    />
  );
};

export default GalleryPage;
